import { useContext } from 'react';

import { UserWebSocketContext } from '../../contexts/auth.contexts';

export const useUserWebSocket = () => {
  const ctx = useContext(UserWebSocketContext);
  if (!ctx) throw new Error('WebSocketProvider missing');
  return ctx;
};
